// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"e07568f2","70":"d9515798","383":"2179829d","453":"1eef1615"}[chunkId] + ".chunk.js";
};